<wp-section-spinner [sectionHeight]="'100%'"></wp-section-spinner>
